<template>
  <modal
    name="assigntoteammodal"
    width="70%"
    :minHeight="300"
    :minWidth="200"
    :maxWidth="800"
    :scrollable="true"
    :adaptive="true"
    :reset="true"
    height="auto"
    @before-open="beforeOpen"
  >
    <div class="modal--container">
      <div class="d-flex justify-content-between pt-3">
        <h4>Assign To Team</h4>
        <button type="button" @click="closeModal" class="close">
          <span aria-hidden="true"
            ><font-awesome-icon icon="times" size="1x"
          /></span>
        </button>
      </div>

      <div class="d-flex flex-column h-100">
        <div class="row mt-4">
          <div class="col-12 col-md-5 form-group multi-container">
            <span class="cus-label">Select Employee's</span>
            <multiselect
              v-model="selected"
              :multiple="true"
              label="name"
              track-by="name"
              placeholder="Select employee"
              :maxHeight="150"
              :options="officeEmployees"
            ></multiselect>
          </div>
        </div>

        <div class="row justify-content-end align-items-end button-container">
          <button
            type="submit"
            class="save_btn hover-dark"
            v-on:click.stop="assignToTeam"
          >
            Assign to Team
          </button>
        </div>
      </div>
    </div>
  </modal>
</template>
<script>
import { massAssignmentToTeam } from "../../../utils/api";
import { mapState, mapGetters } from "vuex";
import Multiselect from "vue-multiselect";
export default {
  name: "AssignToTeamModal",
  data() {
    return {
      officeEmployees: [],
      teamMembers: [],
      selected: null,
      makeAdmin: false
    };
  },
  components: { Multiselect },
  computed: {
    ...mapState(["listOfOfficeEmployeesAll", "officeTeam"]),
    ...mapGetters(["getFirstEmployeeId"])
  },
  methods: {
    beforeOpen(event) {
      this.selected = null;
      this.teamMembers = JSON.parse(JSON.stringify(event?.params?.teamMembers));
      this.teamMembers = this.teamMembers.map(member => member.id);
      this.makeAdmin = JSON.parse(JSON.stringify(event?.params?.makeAdmin));

      this.officeEmployees = this.listOfOfficeEmployeesAll
        .map(emp => {
          return {
            id: emp.id,
            name: `${emp.attributes?.first_name} ${emp.attributes?.last_name}`
          };
        })
        .filter(emp => !this.teamMembers.includes(emp.id));
    },
    assignToTeam() {
      if (!this.selected) {
        this.$swal({
          title: "Select employee/s to assign the team."
        });
        return;
      }

      let params = {
        team_id: this.officeTeam.id,
        employee_ids: this.selected.map(emp => emp.id)
      };
      if (this.makeAdmin) params.admin = true;

      let loader = this.$loading.show();

      massAssignmentToTeam(params, this.officeTeam.id, this.getFirstEmployeeId)
        .then(response => {
          if (response.data) {
            loader.hide();
            this.closeModal();

            if (response?.data?.message)
              this.$swal({
                title: response.data.message,
                confirmButtonText: "OK"
              });

            this.$root.$emit("onUpdateTeam");
          }
        })
        .catch(err => {
          loader.hide();
        });
    },
    closeModal() {
      this.$modal.hide("assigntoteammodal");
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss" scoped>
.button-container {
  margin-top: 200px;
}

h2 {
  font-size: 14px;
  font-weight: normal;
  color: #707070;
}

.modal--container {
  padding: 18px 30px;
  overflow-y: auto;
  height: 100%;
}

.close {
  color: #000000;
}

.cus-label {
  font-size: 14px;
  font-weight: normal;
  font-family: "Helvetica Neue";
  color: #000;
  margin-bottom: 6px;
}
</style>



// WEBPACK FOOTER //
// src/components/OfficeAdmin/Teams/AssignToTeamModal.vue